import React, { Component } from "react";
import styled from "styled-components";
import { Popover } from "@material-ui/core";

import Logos from "js/core/models/logos";
import { getLogoPath } from "common/assetUtils";

const BackgroundImageThumbnail = styled.div`
  width: 160px;
  height: 90px;
  outline: solid 1px #ccc;
  margin-right: 10px;
  margin-bottom: 10px;
  float: left;
  img { 
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ColorPickerContainer = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    margin-right: 10px;
    margin-top: 10px;

    .material-icons {
        opacity: 0;
        position: absolute;
        top: -4px;
        right: -4px;
        font-size: 16px;
    },
    &:hover .material-icons {
        opacity: 1;
    }
`;

const ColorPicker = styled.div`
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: solid 1px #bbb;
`;

const ColorPopover = styled(Popover)`
    padding: 20px;
    width: 250px;
`;

export default class DefaultBackgroundColor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        };
    }

    openOptions = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    closeOptions = () => {
        this.setState({ anchorEl: null });
    };

    selectDefault = value => {
        this.props.update({ defaultBackgroundColor: value });
        this.setState({ anchorEl: null });
    };

    renderColors = () => {
        const { theme } = this.props;
        const colors = theme.colors;
        let colorSet = Object.keys(colors).map(color => {
            const div = (
                <ColorPickerContainer key={color}>
                    <ColorPicker
                        style={{ backgroundColor: colors[color] }}
                        onClick={() => this.selectDefault(color)}
                    />
                </ColorPickerContainer>
            );
            if (color.includes("accent")) {
                return div;
            }
        });
        colorSet.unshift(
            <ColorPickerContainer key={"background_light"}>
                <ColorPicker
                    style={{ backgroundColor: colors.background_light }}
                    onClick={() => this.selectDefault("background_light")}
                />
            </ColorPickerContainer>,
            <ColorPickerContainer key={"background_dark"}>
                <ColorPicker
                    style={{ backgroundColor: colors.background_dark }}
                    onClick={() => this.selectDefault("background_dark")}
                />
            </ColorPickerContainer>,
            <ColorPickerContainer key={"theme"}>
                <ColorPicker
                    style={{ backgroundColor: colors.theme }}
                    onClick={() => this.selectDefault("theme")}
                />
            </ColorPickerContainer>
        );
        if (
            ["gradient", "reverseGradient"].includes(
                this.props.theme.styleBackground
            )
        ) {
            colorSet[0] = (
                <ColorPickerContainer key={"disabled"}>
                    <ColorPicker
                        style={{
                            backgroundColor: theme.colors.background_light,
                            opacity: 0.7,
                            overflow: "hidden"
                        }}
                    >
                        <div
                            style={{
                                width: 3,
                                height: "100%",
                                backgroundColor: "red",
                                transform: "rotate(45deg)",
                                marginLeft: 15
                            }}
                        ></div>
                    </ColorPicker>
                </ColorPickerContainer>
            );
        }

        return colorSet;
    };

    render() {
        const { theme } = this.props;

        return (
            <ColorPickerContainer>
                <ColorPicker
                    style={{ backgroundColor: this.props.theme.colors[theme.defaultBackgroundColor] ?? theme.colors.background_light }}
                    onClick={this.openOptions}
                />
                <ColorPopover
                    disableEnforceFocus
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.closeOptions}
                >
                    <div style={{ width: 300, padding: 16, paddingTop: 4 }}>
                        {this.renderColors()}
                    </div>

                    {theme.backgroundImages &&
                        <div style={{ padding: 16, paddingTop: 4 }}>
                            {theme.backgroundImages
                                .filter(bgImage => bgImage.asset)
                                .map(bgImage => <BackgroundImage onClick={() => this.selectDefault(bgImage.id)} backgroundImage={bgImage} />)
                            }
                        </div>
                    }

                </ColorPopover>
            </ColorPickerContainer>
        );
    }
}

class BackgroundImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: null
        };
    }

    async componentDidMount() {
        let url = await Logos.getSignedUrlAndLoad(getLogoPath(this.props.backgroundImage.asset));
        this.setState({ url });
    }

    render() {
        let { url } = this.state;
        return (
            <BackgroundImageThumbnail onClick={this.props.onClick}>
                <img src={url} />
            </BackgroundImageThumbnail>
        );
    }
}
